import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form, Checkbox, Button } from 'antd';

const PermissionGridWrapper = styled.div`
  width: 90%;
  margin: 1rem auto;
`;

const PermissionGrid = ({ rolePermissions, onSavePermissions, error }) => {
  const { role_permissions, roles } = rolePermissions;
  const [form] = Form.useForm();

  const permissionInitialValues = (role_permissions) => {
    const initialValues = [];
    role_permissions.forEach((rp) => {
      rp.roles.forEach((role) => {
        initialValues.push(`${role}_${rp.id}`);
      });
    });
    console.log({ initialValues });
    return initialValues;
  };
  return (
    <Form
      form={form}
      initialValues={{
        permissions: permissionInitialValues(role_permissions),
      }}
      onFinish={(values) => {
        console.log('Checkbox values>>>', { values });
        onSavePermissions(values);
      }}
    >
      <PermissionGridWrapper>
        <Form.Item
          name="permissions"
          style={{
            margin: 0,
          }}
        >
          <Checkbox.Group style={{ width: '100%' }}>
            <div className="ant-table ant-table-small ant-table-bordered">
              <div className="ant-table-container">
                <div className="ant-table-content">
                  <table>
                    <thead className="ant-table-thead">
                      <tr>
                        <th className="ant-table-cell">Permissions</th>
                        {roles &&
                          roles.map((role) => {
                            return (
                              <th
                                className="ant-table-cell"
                                key={`role-th-${role.id}`}
                              >
                                {role.name}
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {role_permissions &&
                        role_permissions.map((rp) => {
                          return (
                            <tr
                              className="ant-table-row"
                              key={`perm-tr-${rp.id}`}
                            >
                              <td className="ant-table-cell">{rp.name}</td>
                              {roles &&
                                roles.map((role) => {
                                  return (
                                    <td
                                      className="ant-table-cell"
                                      key={`perm-td-${role.id}-${rp.id}`}
                                    >
                                      <Checkbox value={`${role.id}_${rp.id}`}>
                                        {/* {role.id}_{rp.id} -
                                        {rp.roles.indexOf(parseInt(role.id)) >=
                                          0 && 'checked'} */}
                                      </Checkbox>
                                    </td>
                                  );
                                })}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Checkbox.Group>
        </Form.Item>
        <div style={{ margin: '1rem 0', textAlign: 'right' }}>
          <Button type="primary" htmlType="submit">
            Save Permissions
          </Button>
        </div>
      </PermissionGridWrapper>
    </Form>
  );
};

PermissionGrid.defaultProps = {
  rolePermissions: null,
  onSavePermissions: () => {},
  error: false,
};

PermissionGrid.propTypes = {
  rolePermissions: PropTypes.object.isRequired,
  onSavePermissions: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default PermissionGrid;
